<template>
  <div class="container">
    <div class="nav-tab">
      <div style="display: flex">
        <img src="../../../assets/images/arrow.png" class="ims" alt="" />
        <div>您的当前位置是：首页-基层动态</div>
      </div>
      <div class="hover-underline" style="display: flex; margin-right: 56px" @click="returnshow">
        <div style="display: inline-block">
          <img src="../../../assets/images/return.png" class="imgs" alt="" />
        </div>
        返回
      </div>
    </div>
    <div class="content">
      <div>
        <div class="left hover-underline" v-for="item in infoTypeList" :key="item.value" @click="goDept(item.label)">
          <div :class="['banten', searchFrom.deptName == item.value ? 'lanse1' : '']"></div>
          <div :class="['banten2', searchFrom.deptName == item.value ? 'lanse' : '']">
            {{ item.label }}
          </div>
        </div>
      </div>
      <div class="right">
        <div class="box">
          <div class="news">
            <ul class="custom-list">
              <li v-for="(item, index) in featureList" :key="index">
                <div class="li-content hover-underline wid" @click="goInfo(item)">
                  <div>
                    {{ item.messageName }}
                  </div>
                  <div>[{{ item.releaseTime }}]</div>
                </div>
              </li>
            </ul>
          </div>
          <div class="page-container">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page="searchFrom.pageNum" :page-sizes="[10, 20, 30, 40]" :page-size="searchFrom.pageSize"
              layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import { listAll } from "@/api/index";

export default {
  name: "ImportantNews",
  props: ["deptName"],
  data() {
    return {
      infoTypeList: [
        { label: "贵池", value: 0 },
        { label: "东至", value: 3 },
        { label: "石台", value: 1 },
        { label: "青阳", value: 4 },
        { label: "九华山", value: 2 },
        { label: "特勤", value: 5 },
      ],
      featureList: [], // 消防要闻
      searchFrom: {
        pageNum: 1,
        pageSize: 20,
        messageType: 3,
        status: 4,
      },
      guichi: [],
      shitai: [],
      jiuhuashan: [],
      dongzhi: [],
      qingyang: [],
      teqin: [],
      total: '',
      deptName: '',
    };
  },
  mounted() {
    if (this.deptName == "贵池") {
      this.searchFrom.deptName = "0";
      this.getlistAll();
    }
    if (this.deptName == "石台") {
      this.searchFrom.deptName = "1";
      this.getlistAll();
    }
    if (this.deptName == "九华山") {
      this.searchFrom.deptName = "2";
      this.getlistAll();
    }
    if (this.deptName == "东至") {
      this.searchFrom.deptName = "3";
      this.getlistAll();
    }
    if (this.deptName == "青阳") {
      this.searchFrom.deptName = "4";
      this.getlistAll();
    }
    if (this.deptName == "特勤") {
      this.searchFrom.deptName = "5";
      this.getlistAll();
    }
  },
  methods: {
    handleSizeChange(val) {
      this.searchFrom.pageSize = val;
      this.getlistAll();
    },
    handleCurrentChange(val) {
      this.searchFrom.pageNum = val;
      this.getlistAll();
    },
    goDept(txt) {
      this.deptName = txt
      this.searchFrom.pageNum = 1;
      if (this.deptName == "贵池") {
        this.searchFrom.deptName = "0";
        this.getlistAll();
      }
      if (this.deptName == "石台") {
        this.searchFrom.deptName = "1";
        this.getlistAll();
      }
      if (this.deptName == "九华山") {
        this.searchFrom.deptName = "2";
        this.getlistAll();
      }
      if (this.deptName == "东至") {
        this.searchFrom.deptName = "3";
        this.getlistAll();
      }
      if (this.deptName == "青阳") {
        this.searchFrom.deptName = "4";
        this.getlistAll();
      }
      if (this.deptName == "特勤") {
        this.searchFrom.deptName = "5";
        this.getlistAll();
      }
    },
    goInfo(item) {
      // 使用window.open方法在新窗口或选项卡中打开链接
      const ids = item.id;
      const url = `/?ids=${encodeURIComponent(ids)}`;
      window.open(url, "_blank");
    },
    getlistAll() {
      // axios.post('/api/message/release/queryList', this.searchFrom).then(res=>{
      // })
      listAll(this.searchFrom).then((res) => {
        this.featureList = res.data.data.list;
        this.total = res.data.data.total;
        this.featureList.forEach((item) => {
          if (item.messageName.length > 42) {
            item.messageName = item.messageName.slice(0, 42) + "...";
          }
          if (item.releaseTime) {
            item.releaseTime = item.releaseTime.slice(5, 10);
          }
        });
      });
    },
    returnshow() {
      this.$emit("setCilck");
    },
  },
};
</script>

<style scoped lang="scss">
#map {
  width: 100%;
  height: 398px;
}

.container {
  width: 100%;
  background: #fff;
}

.nav-tab {
  width: 1120px;
  height: 48px;
  background: #f5f5f5;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;

  .ims {
    width: 23px;
    height: 20px;
    margin-left: 40px;
  }

  .imgs {
    width: 16px;
    margin: 0;
    height: 14px;
    vertical-align: middle;
    margin-right: 8px;
  }

  div {
    font-size: 16px;
    color: #2b56ac;
    margin-left: 16px;
  }
}
.page-container{
  display: flex;
  justify-content: right;
}
.hover-underline {
  cursor: pointer;
  /* 鼠标悬停时显示手形光标 */
}

.hover-underline:hover {
  text-decoration: underline;
  /* 悬停时添加下划线 */
}

.content {
  width: 1080px;
  height: 650px;
  margin: 0 auto;
  margin-top: 40px;
  margin-left: 40px;
  display: flex;
  justify-content: start;
  align-items: flex-start;
  background-color: #fff;

  .custom-list {
    list-style-type: none;
    padding: 0 20px 0 12px;
    width: 788px;
  }

  .custom-list li {
    position: relative;
    padding-left: 18px;
    margin: 10px 0;
  }

  .custom-list li::before {
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 4px;
    height: 4px;
    background-color: #c1c5cd;
    border-radius: 50%;
  }

  .li-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;

    span {
      display: inline-block;
      width: 40px;
      height: 18px;
      line-height: 18px;
      text-align: center;
      background: #ffdfdf;
      border-radius: 4px;
      font-size: 10px;
      color: #cc0000;
      // margin-left: 10px;
    }

    .bgc {
      background-color: #f6f6f6;
    }
  }

  .custom-link {
    color: inherit;
    text-decoration: none;
  }

  .left {
    display: flex;

    .banten {
      width: 6px;
      height: 50px;

      border-radius: 0px 0px 0px 0px;
    }

    .banten2 {
      width: 156px;
      height: 50px;
      line-height: 50px;
      
      border-radius: 0px 0px 0px 0px;
      font-weight: bold;
      font-size: 18px;
      padding-left: 24px;
    }

    .lanse {
      color: #2b56ac;
      background: #eef1f8;
    }

    .lanse1 {
      background: #2b56ac;
    }
  }

  .right {
    width: 780px;
    background: #ffffff;
    margin-left: 40px;



    .box {
      width: 780px;
      height: 620px;
    }

    .news {
      min-height: 500px;
    }

    .detachment-leader {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      padding: 40px 60px 0 60px;

      img {
        width: 180px;
        height: 180px;
        margin-bottom: 16px;
      }

      .name-detail {
        width: 180px;
        text-align: center;
      }
    }

    .detachment-leader>div:nth-child(2),
    .detachment-leader>div:nth-child(5) {
      margin-left: 90px;
      margin-right: 90px;
    }

    .intro {
      padding-top: 40px;
      background-color: #fff;

      #text {
        display: inline-block;
      }
    }

    .location {
      padding-top: 40px;
    }
  }
}

.bottom-info {
  width: 1120px;
  height: 100px;
  background: #0e67ab;
  color: #fff;
  font-size: 14px;
  margin: 0 auto;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;

  .bottom-box div {
    margin: 6px 0;
    text-align: center;
  }
}

.images {
  width: 64px;
  height: 24px;
  margin-top: 22px;

  img {
    width: 64px;
    height: 24px;
  }
}

.hover-underline {
  cursor: pointer;
  /* 鼠标悬停时显示手形光标 */
}

.hover-underline:hover {
  text-decoration: underline;
  /* 悬停时添加下划线 */
}
</style>
